import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { Tooltip as ReactTooltip } from "react-tooltip";
import SvgIcon from "../../../../parts/SvgIcon";
import { isCoach } from "../../../../utils/user-helpers";
import { getUserToRequest } from "../../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";

const PERIODIZATION_TOOLTIP_ID = "annual-planner-moved-tooltip";

const PeriodizationMovedItem = ({ t, urlStart, route, urlEnd }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <li>
      <a
        href={`${urlStart}${route}?section=periodization${urlEnd}`}
        className="linkx alt"
        style={{ opacity: 0.6, gap: "0.4rem" }}
      >
        {t("metrics.annualPlanner")}
        <SvgIcon
          alt={t("metrics.annualPlannerMovedSubtext")}
          src="/img/new-icons/question-circle.svg"
          style={{ cursor: "pointer" }}
          data-tooltip-id={PERIODIZATION_TOOLTIP_ID}
          data-tooltip-content={t("metrics.annualPlannerMovedSubtext")}
        />
      </a>
      {mounted &&
        createPortal(
          <ReactTooltip
            id={PERIODIZATION_TOOLTIP_ID}
            className="React-Tooltip custom-style z-50"
            place="top"
            positionStrategy="fixed"
            opacity={1}
          />,
          document.body
        )}
      <img
        className="only-show-mobile"
        src="/img/new-icons/arrow-right.svg"
        alt=""
      />
    </li>
  );
};

const NavigationSections = ({
  linksArr,
  activeUser,
  organizationOwner,
  urlStart,
  urlEnd,
  pathNameWithoutEndingSlash,
  view,
  date,
}) => {
  const { t } = useTranslation("athlete-portal");
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const isPushDemoAccount = /\+push(review)?@/.test(activeUser.email ?? "");

  return linksArr.map(
    ({ route, metricKey, className, queryParams, key }, idx) => {
      if (key === "strengthMetrics" && !!userToRequest.hideStrengthMetrics) {
        return null;
      }

      if (key === "checkInSummary" && !isCoach(activeUser)) {
        return null;
      }
      if (
        key === "accountability" &&
        (userToRequest.subscription || isPushDemoAccount)
      ) {
        return null;
      }
      if (key === "blockReview" && !isCoach(activeUser)) {
        return null;
      }

      if (key === "periodizationMoved") {
        return (
          <PeriodizationMovedItem
            key={key}
            t={t}
            urlStart={urlStart}
            route={route}
            urlEnd={urlEnd}
          />
        );
      }

      const active = `${urlStart}${route}` === pathNameWithoutEndingSlash;
      const userMeasure =
        userToRequest.intensityMeasure === "rir" ? "RiR" : "RPE";
      const labelToShow =
        metricKey === "rpeTable"
          ? t("metrics.measureTable", { measure: userMeasure })
          : t(`metrics.${metricKey}`);

      const redirect =
        metricKey === "rpeTable"
          ? `${urlStart}${route}?${
              view ? "view=day&" : ""
            }display=repMax${urlEnd}`
          : `${urlStart}${route}?${view ? "view=day&" : ""}date=${date}${urlEnd}`;

      return (
        <li
          key={`${key || metricKey}-${idx}`}
          className={`${active ? "active" : ""}${
            ["blockReview"].includes(key) ? " mobile-hidden" : "" // hidding for mobile cause responsive is not yet ready
          }`}
        >
          <a
            href={redirect}
            className={`linkx alt${className ? ` ${className}` : ""}`}
          >
            {labelToShow}
          </a>
          <img
            className="only-show-mobile"
            src="/img/new-icons/arrow-right.svg"
          />
          {/* {label === "Check-in Summary" ||
          (label === "Body Measurements" && (
            <span role="new-report"> (new)</span>
          ))} */}
        </li>
      );
    }
  );
};

export default NavigationSections;
